import { Injectable, Inject } from '@angular/core';
import {DOCUMENT} from '@angular/common';
import { GlobalService } from 'src/app/services/global/global.service';

// ref: https://stackoverflow.com/questions/54929956/ionic-4-with-angular-how-to-set-dynamic-html-dir-attribute
// ref: https://stackblitz.com/edit/angular-p8riqb

/*
  (property) Platform.isRTL: boolean
  Returns if this app is using right-to-left language direction or not. 
  We recommend the app's index.html file already has the correct dir attribute value set, such as <html dir="ltr"> or <html dir="rtl">. W3C: Structural markup and right-to-left text in HTML

  https://www.w3.org/International/questions/qa-html-dir
  https://github.com/ionic-team/ionic/issues/17012
  https://stackblitz.com/edit/angular-p8riqb
*/

type ReadingDirection = 'ltr' | 'rtl';

@Injectable({
  providedIn: 'root'
})
export class DocumentService 
{
  consoleLog:boolean = false;

  constructor( 
      @Inject(DOCUMENT) private doc
    , private globalProvider: GlobalService
    ) 
  {
    // NOTE: the constructor ONLY gets called ONCE during the app life cycle
    this.consoleLog = this.globalProvider.consoleLog_document;
    if (this.consoleLog) console.log('Document.ctor - LifeCycle');
  }

  public setReadingDirection(dir: ReadingDirection) 
  {
    this.doc.dir = dir;
  }
}
